import React from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Dialog, FormControlLabel, Menu, CardHeader, Slide, MenuItem, Radio, RadioGroup, Button, CircularProgress, AppBar, Toolbar, IconButton, Typography, Divider } from '@material-ui/core'
import { index, destroy } from '../../../../store/actions/menor.gestao.action'
import { changeScreenB, changeScreenC } from '../../../../store/actions/navigation.action'
import { MdKeyboardBackspace } from 'react-icons/md'
import { FaPencilAlt, FaTrash, FaPlus, FaEye, FaEyeSlash } from 'react-icons/fa'
import { FcFilingCabinet } from 'react-icons/fc'
import { MdMoreHoriz } from 'react-icons/md'
import { Confirm } from '../../../components'
import Detail from '../../premiada/detail'
import Fullname from '../../../components/Fullname'

export default function MenorGestao(props) {
    const dispatch = useDispatch()
    const { cotas } = useSelector(state => state.menorGestaoReducer)
    const campaign_id = (props.campaign_id) ? props.campaign_id : null;

    const [isLoad, setLoad] = React.useState(true)
    const [isLoading, setLoading] = React.useState(true)

    const [status, setStatus] = React.useState(1)
    const [view, setView] = React.useState('default')
    const [preView, setPreView] = React.useState('default')
    const [isMenu, setMenu] = React.useState(false)

    const [detail, setDetail] = React.useState({
        id: null,
        open: false
    })

    const [state, setState] = React.useState({
        isDeleted: null,
        menuEl: null,
        confirmEl: null
    })

    React.useEffect(() => {
        _index()
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [status])

    React.useEffect(() => {
        if(view === 'list-editor' || preView === 'list-editor') {
            _index()
        }
        //eslint-disable-next-line react-hooks/exhaustive-deps
    }, [view])

    const _index = () => {
        setLoad(true)
        dispatch(index({
            campaign_id: campaign_id,
            status: status,
            editor: view === 'list-editor' ? 'desc' : null
        })).then(() => {
            setLoad(false)
            setLoading(false)
        })
    }

    const handlePage = (page, campaign_id = null, id = null) => {
        dispatch(changeScreenC({
            open: true,
            type: page,
            props: {
                campaign_id: campaign_id,
                uid: id,
                view: view
            }
        }))
    }

    const _destroy = (id) => {
        setState({ isDeleted: id })
        dispatch(destroy(id)).then(res => res && setState({ isDeleted: null }))
    }

    const _detail = (id) => {
        setDetail({
            id: id,
            open: true
        })
    }

    const _text = (string) => {
        let text = ""
        for (let index = 0; index < string.length; index++) {
            text = text + "0"
        }

        return text
    }

    const Transition = React.forwardRef((props, ref) => {
        return <Slide direction="up" ref={ref} {...props} />
    })

    return (
        <>
            <AppBar position="fixed">
                <Toolbar>
                    <IconButton onClick={() => dispatch(changeScreenB({ open: false }))} edge="start" color="inherit">
                        <MdKeyboardBackspace />
                    </IconButton>
                    <Typography variant="h6">Gerenciar Cotas</Typography>
                    
                    <Button 
                        variant="contained" 
                        size="small" 
                        onClick={() => handlePage('menor-gestao-create', campaign_id)}
                        color="inherit" 
                        className="ms-auto btn-app-bar"
                        startIcon={<FaPlus />}
                    >
                        Cadastrar
                    </Button>
                </Toolbar>
            </AppBar>

            <Dialog
                open={detail.open}
                maxWidth="sm"
				style={{width: '100%'}}
                onClose={() => setDetail({ id: null, open: false })}
                className="center"
            >   
                <Detail view="list-editor" uid={detail.id} onClose={() => setDetail({ id: null, open: false })}/>
            </Dialog>


            <div className="mt-5 pt-1 bg-clear min-vh-100">

            {(isLoading) ? <div className="d-flex justify-content-center mt-5 pt-5"> <CircularProgress /> </div> :
                <>
                    <div className="card-body d-flex justify-content-between">
                        <label className="label-custom m-0 bs-color">{cotas.length.toLocaleString('pt-BR', {style: 'decimal'})} registro(s)</label>
                        
                        <div className="d-flex gap-3">
                            <IconButton 
                                className="p-0 bs-color" 
                                onClick={() => {
                                    setPreView(view)
                                    setView(view === 'list-editor' ? 'default' : 'list-editor')
                                }}
                            >
                                {view === "list-editor" ?
                                    <FaEye size="1.2em" />
                                :
                                    <FaEyeSlash size="1.2em" />
                                }  
                            </IconButton> 
                        </div>
                    </div>

                    <div className="card p-3 mb-2 bs-bg">
                        <div>
                            <RadioGroup
                                row
                                name="type"
                                value={parseInt(status)}
                                onChange={text => setStatus(text.target.value)}
                                className="fw-bold bs-color-b"
                            >
                                <FormControlLabel value={1} control={<Radio color="primary" />} label="TODAS" />
                                <FormControlLabel value={2} control={<Radio color="primary" />} label="DISPONIVEIS" />
                                <FormControlLabel value={3} control={<Radio color="primary" />} label="VENDIDAS" />
                            </RadioGroup>
                        </div>
                    </div>

                    {(isLoad) ? <div className="d-flex justify-content-center m-5 p-5"> <CircularProgress /> </div> :
                        <>

                        {(cotas.length < 1) &&
                            <div className="card card-body mt-3 bs-bg">
                                <div className="text-center mt-5 pt-5 mb-5 pb-5">
                                    <FcFilingCabinet size="70" />
                                    <h6 className="mt-4 text-muted bs-color">Nenhum registro encontrado</h6>
                                </div>
                            </div>
                        }

                        {(cotas.length > 0) &&
                            <>
                                {cotas.map((item, index) => (
                                    <div className={"card pointer bs-bg list-items"+(item.has_instant_prize ? ' opacity-5' : '')} key={index}>
                                        <CardHeader
                                            className="pt-2 pb-2"
                                            avatar={
                                                <button onClick={() => _detail(item.id)} type="button" className={"position-relative fw-bold btn "+ (item.user_id ? 'btn-secondary' : 'btn-success')}>
                                                    <span className="position-absolute">{item.quota_number}</span>
                                                    <span className="invisible">{_text(item.quota_number)}</span>
                                                </button>
                                            }
                                            title={<>
                                                <div className="d-flex" onClick={() => _detail(item.id)}>
                                                    <h6 className="m-0 fw-bold position-relative me-3 bs-color-b">
                                                        <span className="position-absolute">{item.position ? item.position + '%' : ''}</span>
                                                        <span className="invisible">00.00%</span>
                                                    </h6>
                                                    <h6 className="m-0 fw-bold bs-color-b">{item.title ? item.title.substring(0,25) : item.title}</h6>
                                                </div>
                                            </>}
                                            subheader={
                                                <> 
                                                    {item.user_id &&
                                                        <>
                                                        <span onClick={() => _detail(item.id)} className="d-block bs-color">{<Fullname fullName={item.user_name ? item.user_name.substring(0,25) : item.user_name} />}</span>
                                                        <small className="bs-color" onClick={() => _detail(item.id)}>{new Intl.DateTimeFormat('pt-BR', {year: '2-digit', month: '2-digit',day: '2-digit'}).format(new Date(item.time_at))} {new Intl.DateTimeFormat('pt-BR', {hour: '2-digit', minute: '2-digit'}).format(new Date(item.time_at))}</small>
                                                        </>
                                                    }
                                                </>
                                            }
                                            
                                            action={
                                                <h6 className="fw-bold pt-3 pe-3">
                                                    <MdMoreHoriz className="bs-color" id={index} onClick={event => setState({ menuEl: event.currentTarget })} size={28} />
                                                </h6>
                                            }
                                        />

                                        {(Boolean(state.menuEl)) &&
                                            <Menu
                                                anchorEl={state.menuEl}
                                                transformOrigin={{ vertical: 'top', horizontal: 'right' }}
                                                TransitionComponent={Transition}
                                                open={(index === parseInt(state.menuEl.id))}
                                                onClose={() => setState({ menuEl: null })}
                                            >
                                                {(!item.has_instant_prize) &&
                                                    <div>
                                                        <MenuItem 
                                                            onClick={() => {
                                                                setState({ menuEl: null })
                                                                handlePage('menor-gestao-edit', campaign_id, item.id)
                                                            }}
                                                            className="bs-color-b"
                                                        >
                                                            <FaPencilAlt size="1.2em" className="me-4" /> <strong>Editar</strong>
                                                        </MenuItem>
                                                        
                                                        <Divider />
                                                    </div>
                                                }

                                                <MenuItem 
                                                    onClick={() => setState({ confirmEl: item.id })}
                                                    className="bs-color-b"
                                                >
                                                    <FaTrash color="#dc3545" size="1.2em" className="me-4" /> <strong>Apagar</strong>
                                                </MenuItem>

                                                <div className='mt-3'></div>
                                            </Menu>
                                        }
                                        {(state.confirmEl === item.id) && 
                                            <Confirm
                                                open={(item.id === state.confirmEl)}
                                                onClose={() => setState({ confirmEl: null })}
                                                onConfirm={() => _destroy(item.id)}
                                                title="Tem certeza que deseja remover ?"
                                            />
                                        }
                                    </div>
                                ))}
                            </>
                        }
                    </>
                    }
                </>
            }
            </div>
        </>
    )
}